import { combineReducers } from "redux";

function buildRootReducer(globalReducers, appReducers, pageReducers) {
  return combineReducers({
    global: combineReducers(globalReducers),
    app: appReducers ? combineReducers(appReducers) : {},
    pages: pageReducers ? combineReducers(pageReducers) : {},
  });
}

export { buildRootReducer };
